// @ts-ignore
import * as L from 'leaflet/dist/leaflet-src.esm.js';
import { XmlHelper } from '../../../../helpers';
export class WmsRequest {
    /**
      * It takes a url, appends a query string to it, fetches the response,
      * parses the response as XML, and returns the result.
      * @param {string} url - the url of the WMS service
      * @returns The result is a parsed XML document.
      */
    static async getCapabilities(url) {
        const result = await fetch(`${url}?request=GetCapabilities`)
            .then((response) => response.text())
            .then((str) => XmlHelper.parseXML(str));
        return result;
    }
    /**
     * It takes a map, a latlng, and a layer, and returns a URL that can be used
     * to query the layer for information about the features
     * @param {Map} map - Map - the map object
     * @param {LatLng} latLng - The lat/lng of the point where the user clicked.
     * @param {IOverlayBasicLayer} layer - ILayer - this is the layer
     * that you want to get the feature info from
     * @returns The response is a JSON object with the following structure:
     */
    static getFeatureInfoUrl(map, latLng, layer) {
        // Construct a GetFeatureInfo request URL given a point
        const point = map.latLngToContainerPoint(latLng);
        const size = map.getSize();
        // this crs is used to show layer added to map
        const { crs } = map.options;
        if (!crs)
            return '';
        // these are the SouthWest and NorthEast points
        // projected from LatLng into used crs
        const sw = crs.project(map.getBounds().getSouthWest());
        const ne = crs.project(map.getBounds().getNorthEast());
        const params = {
            request: 'GetFeatureInfo',
            service: 'WMS',
            crs: crs.code,
            styles: layer.layers.map((l) => l.style).join(','),
            transparent: layer.opacity,
            version: layer.version,
            bbox: `${sw.x},${sw.y},${ne.x},${ne.y}`,
            height: size.y,
            width: size.x,
            layers: layer.layers.map((l) => l.layer).join(','),
            query_layers: layer.layers.map((l) => l.layer).join(','),
            cql_filter: layer.layers.map((l) => l.cql_filter).join(';'),
            viewparams: layer.layers.map((l) => l.viewParams).join(';'),
            info_format: 'application/json',
            feature_count: 25,
            buffer: 8,
        };
        params[params.version === '1.3.0' ? 'i' : 'x'] = Math.round(point.x);
        params[params.version === '1.3.0' ? 'j' : 'y'] = Math.round(point.y);
        return layer.url + L.Util.getParamString(params, layer.url, true);
    }
    /**
     * This function takes a map, a latLng, and a layer, and returns a promise that resolves to the
     * result of a WMS GetFeatureInfo request.
     * @param {Map} map - Map - the map object
     * @param {LatLng} latLng - the lat/lng of the point clicked on the map
     * @param {any} layer - Overlay basic layer
     * @returns The resultFeatureInfo is a JSON object.
     */
    static async getFeatureInfo(map, latLng, layer) {
        let resultFeatureInfo = null;
        if (layer.type === 'OverlayBasicLayer') {
            const wmsLayer = { ...layer };
            const url = this.getFeatureInfoUrl(map, latLng, wmsLayer);
            resultFeatureInfo = await fetch(url)
                .then((response) => response.json())
                .then((data) => data);
        }
        return resultFeatureInfo;
    }
}
//# sourceMappingURL=wmsRequest.js.map